/* eslint-disable camelcase */

/**
 * A Rate Group
 * @param {integer} id - RateGroup ID
 * @param {integer} event - event fk
 * @param {string} name - Name
 * @param {integer} parent - parent group
 * @param {integer} display_order - display order
 * @param {Object} translations - translations
 * @param {array} rates - array of Rates
 * @param {array} subGroups - array of subGroups ids
 * @returns {Class} - RateGroup Class
**/
class RateGroup {
	constructor({
		id,
		event,
		name,
		parent,
		display_order,
		translations,
		rates,
		subGroups,
		group_template,
	} = {}) {
		this._id = id;
		this._event = event;
		this._name = name;
		this._parent = parent;
		this._display_order = display_order;
		this._translations = translations;
		this._group_template = group_template;
	}

	getId() {
		return this._id;
	}

	getKey() {
		return String(this._id);
	}

	getEvent() {
		return this._event;
	}

	getName() {
		return this._name;
	}

	getParent() {
		return this._parent && String(this._parent);
	}

	getDisplayOrder() {
		return this._display_order;
	}

	getTranslations() {
		return this._translations;
	}

	getTemplateName() {
		return this._name || this._group_template?.name;
	}
}

export default RateGroup;
